import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "#7D7FAD",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
      opacity: ".3"
    }, null, -1),
    createElementVNode("path", {
      stroke: "#7D7FAD",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M10 1a9 9 0 0 1 9 9"
    }, null, -1)
  ])]);
}
const LoadingIcon = { render };
export {
  LoadingIcon as default,
  render
};
//# sourceMappingURL=loading-icon.svg.js.map
